import Flickity from 'flickity';

const initProjectSlider = (sections) => {
    sections.forEach((slider) => {
        const nextButton = slider.querySelector('.js-project-slider-btn');

        const flkty = new Flickity(slider, {
            cellSelector: '.js-cell',
            prevNextButtons: false,
            cellAlign: 'center',
            pageDots: false,
            wrapAround: true,
            draggable: true,
            autoplay: false,
            imagesLoaded: true,
        });

        if (nextButton) {
            nextButton.addEventListener('click', () => {
                flkty.next();
            });
        }

        flkty.on('dragStart', () => {
            flkty.slider.style.pointerEvents = 'none';
        });
        flkty.on('dragEnd', () => {
            flkty.slider.style.pointerEvents = 'auto';
        });
    });
};

export default initProjectSlider;
